import api from '@/utils/api'

export default {
    getStatsByLeague(leagueId, phase, season) {
        return api.get(`teams/stats/league/${leagueId}?phase=${phase}&seasonId=${season}`)
    },

    getStatsByCupLeague(leagueId, season) {
        return api.get(`teams/stats/cup-league/${leagueId}?seasonId=${season}`)
    }
}
